<template>
  <div class="container">
    <div class="context-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto mt-1">
              <h3 class>Gerenciar Solicitações</h3>
            </div>
            <div class="col-auto m-2">
              <b-button v-if="isAdministrador" variant="outline-dark" download="solicitacoes.xls" :href="`${baseURL}/api/solicitacoes/export-xls`">
                <i class="fas fa-file-excel"></i> Exportar
              </b-button>
            </div>
          </div>
        </div>

        <div class>
          <div class="text-right">
            <b-button v-b-toggle.collapse-1 variant="primary">
              <i class="fa fa-filter"></i>
              Filtros
            </b-button>
          </div>
          <b-collapse id="collapse-1" class="mt-2">
            <b-card header="Filtros para aplicar">
              <div class="container">
                  <div class="row">
                      <div class="col-6">
                          <div class="form-group">
                            <label>Status Solicitação</label>
                            <multiselect v-model="filtro.status" :multiple="true" 
                            :taggable="true" :options="statusSolicitacao" label="name" value="code" track-by="code"
                            :hide-selected="true" :showLabels="false"
                            :searchable="false" placeholder="Selecione o status do pedido"></multiselect>
                          </div>
                      </div>
                      <div class="col-3">
                          <div class="form-group">
                              <label>Id Pedido</label>
                              <input type="cel" class="form-control" v-model="filtro.idPedido">
                          </div>
                      </div>
                      <div class="col-3">
                          <div class="form-group">
                              <label>Código</label>
                              <input type="cel" class="form-control" v-model="filtro.codigo">
                          </div>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-3">
                          <div class="form-group">
                              <label>CPF Cliente</label>
                              <input type="cel" v-mask="'###.###.###-##'" class="form-control" v-model="filtro.clientCpf">
                          </div>
                      </div>
                      <div class="col-6">
                          <div class="form-group">
                              <label>Nome Cliente</label>
                              <input type="cel" class="form-control" v-model="filtro.clientName">
                          </div>
                      </div>
                  </div>
                  <div class="row text-right">
                    <div class="col">
                      <b-link @click="limpar" class="mr-2">Limpar</b-link>
                      <b-button v-b-toggle.collapse-1 @click="find" variant="primary">Aplicar</b-button>
                    </div>
                  </div>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <div class="mt-3">
          <b-card>
            <div class="row">
              <b-col class="my-1">
                <b-pagination
                  v-if="totalRows > 10"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </div>
            <b-table
              :busy="loading" fixed
              :current-page="currentPage" :per-page="perPage"
              ref="my-table"
              id="my-table"
              hover
              :items="solicitacoes"
              :fields="fields"
            >
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>
              <template slot="[actions]" slot-scope="row">
                  <b-button title="Atender" variant="light"
                  v-if="row.item.status !== 'Concluida'"
                  @click="atenderSolicitacao(row.item)">
                    <i class="fas fa-ok">
                        <img width="16" src="@/assets/img/atendimento.svg">
                    </i>
                  </b-button>
                  <b-button title="Visualizar" variant="light" @click="visualizarSolicitacao(row.item)">
                    <i class="fas fa-search"></i>
                  </b-button>
              </template>
            </b-table>
          </b-card>
        </div>
        
      </div>
    </div>

    <b-modal id="modalVisualizarSolicitacao" size="lg"
        ref="modalVisualizarSolicitacao" ok-only
        title="Visualizar Solicitação">
        <div class="container" v-if="solicitacao">
            <div class="row">
                <div class="col">
                    <label>Código</label><br>
                    <h5>{{solicitacao.codigo}}</h5>
                </div>
                <div class="col">
                    <label>Pedido</label><br>
                    <h5>{{solicitacao.pedido.idPedidoVindi}}</h5>
                </div>
                <div class="col">
                    <label>Data/Hora</label>
                    <h5>{{solicitacao.createdAt | formatDate}}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Empresa</label><br>
                    <h5>{{solicitacao.juridica.name}}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Solicitante</label><br>
                    <h5>{{solicitacao.usuarioSolicitante.name}}</h5>
                </div>
                <div class="col-3">
                    <label>Status</label>
                    <h5>{{solicitacao.status}}</h5>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                    <label>Descrição</label>
                    <textarea
                        v-model="solicitacao.descricao"
                        v-validate="'required'"
                        disabled
                        name="solicitacaoDescricao"
                        id="solicitacaoDescricao"
                        cols="30"
                        rows="10"
                        class="form-control"
                    ></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                    <label>Descrição do atendimento</label>
                    <textarea
                        v-model="solicitacao.textoAtendimento"
                        v-validate="'required'"
                        disabled
                        name="solicitacaoDescricao"
                        id="solicitacaoDescricao"
                        cols="30"
                        rows="10"
                        class="form-control"
                    ></textarea>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
    <b-modal id="modalSolicitacao" ref="modalSolicitacao" size="lg"
        hide-footer
        title="Atender Solicitação">
        <div class="container" v-if="solicitacao">
            <div class="row">
                <div class="col">
                    <label>Código</label><br>
                    <h5>{{solicitacao.codigo}}</h5>
                </div>
                <div class="col">
                    <label>Pedido</label><br>
                    <router-link target="_blank" :to="{name: 'PedidoDetail', query:{id: solicitacao.pedido._id}}">
                        <h5>#{{solicitacao.pedido.idPedidoVindi}}</h5>
                    </router-link>
                </div>
                <div class="col">
                    <label>Data/Hora</label>
                    <h5>{{solicitacao.createdAt | formatDate}}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Empresa</label><br>
                    <h5>{{solicitacao.juridica.name}}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Solicitante</label><br>
                    <h5>{{solicitacao.usuarioSolicitante.name}}</h5>
                </div>
                <div class="col-3">
                    <label>Status</label>
                    <h5>{{solicitacao.status}}</h5>
                </div>
            </div>
            <div class="row" v-if="solicitacao.usuarioAtendente">
                <div class="col">
                    <label>Atendido Por</label><br>
                    <h5>{{solicitacao.usuarioAtendente.name}}</h5>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                    <label>Descrição</label>
                    <textarea
                        v-model="solicitacao.descricao"
                        v-validate="'required'"
                        disabled
                        name="solicitacaoDescricao"
                        id="solicitacaoDescricao"
                        cols="30"
                        rows="10"
                        class="form-control"
                    ></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group" :class="{'has-danger': errors.has('textoAtendimento')}">
                    <label for="textoAtendimento">Texto de atendimento</label>
                    <textarea
                        v-model="solicitacao.textoAtendimento"
                        v-validate="'required'"
                        name="textoAtendimento"
                        id="textoAtendimento"
                        cols="30"
                        rows="10"
                        class="form-control"
                    ></textarea>
                    <div
                      v-if="errors.has('textoAtendimento')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('textoAtendimento')}}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <b-button @click="concluirSolicitacao">Concluir</b-button>
                </div>
            </div>
        </div>
    </b-modal>

  </div>
</template>
<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect'
import _ from 'lodash';

export default {
  components: {
    Multiselect
  },
  methods: {
    async atenderSolicitacao(solicitacao) {
        let response;
        if (solicitacao.usuarioAtendente && this.user._id === solicitacao.usuarioAtendente._id) {
            response = true;
        } else {
            response = await this.$bvModal.msgBoxConfirm('Deseja realmente realizar o atendimento desta solicitação?', {
             title: 'Confirmação',
             size: 'sm',
             buttonSize: 'sm',
             okVariant: 'danger',
             okTitle: 'Sim',
             cancelTitle: 'Não',
             footerClass: 'p-2',
             hideHeaderClose: false,
             centered: true
           });
        }

        if (response) {
            this.solicitacao = solicitacao;
            await axios.put(`/api/solicitacoes/${this.solicitacao._id}`, {usuarioAtendente: this.user, status: 'Em Atendimento'});
            this.$bvModal.show("modalSolicitacao");
        }
    },
    async concluirSolicitacao() {
        const result = await this.$validator.validateAll();
        if (result) {
            await axios.put(`/api/solicitacoes/${this.solicitacao._id}`, {textoAtendimento: this.solicitacao.textoAtendimento, usuarioAtendente: this.user, status: 'Concluida'});
            await this.find();
            this.$bvModal.hide("modalSolicitacao");
        }
    },
    visualizarSolicitacao(solicitacao) {
        this.solicitacao = solicitacao;
        this.$bvModal.show('modalVisualizarSolicitacao');
    },
    async find() {
        this.currentPage = 1;
        this.$store.dispatch("setLoadingTable", true);
        this.$root.$emit('bv::refresh::table', 'my-table')
        this.$store.dispatch("setLoadingTable", false);
    },
    solicitacoes(ctx) {
      const filtro = _.cloneDeep(this.filtro);

      if (filtro.status) {
        filtro.status = filtro.status.map(st => st.code);
      }

      filtro.limit = ctx.perPage;
      filtro.page = ctx.currentPage;
      
      this.currentPage = ctx.currentPage;

      const promise = axios.get('/api/solicitacoes/find', {
        params: filtro
      });
      return promise.then(response => {
        let result = response.data;
        this.totalRows = result.totalCount;

        const items = result.data;
        return items || []
      });
    }
  },
  computed: {
    empresa() {
        return this.$store.gettes.empresa;
    },
    loading() {
      return this.$store.getters.loadingTable;
    },
    user() {
      return this.$store.getters.user;
    },
    isAdministrador() {
      return this.$store.getters.isAdministrador;
    },
    baseURL(){
      return axios.defaults.baseURL;
    }
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      solicitacao: null,
      statusSolicitacao: [{code: 'Cancelada', name: 'Cancelada'}, {code: 'Concluida', name: 'Concluida'}, {code: 'Aguardando', name: 'Aguardando'}, {code: 'Em Atendimento', name: 'Em Atendimento'}],
      fields: [
        { key: "codigo", label: "Código", thStyle: {'width': '8%'} },
        { key: "createdAt", label: 'Data/Hora', sortable: true, formatter: value => this.$options.filters.formatDate(value), thStyle: {'width': '10%'}},
        { key: 'pedido.idPedidoVindi', label: 'ID Pedido', thStyle: {'width': '8%'}},
        { key: 'descricao', label: 'Descrição', formatter: value => this.$options.filters.truncate(value, 100), thStyle: {'width': '28%'}},
        { key: 'juridica.name', label: 'Empresa', thStyle: {'width': '8%'}},
        { key: 'usuarioSolicitante.name', label: 'Solicitado Por', thStyle: {'width': '8%'}},
        { key: 'usuarioAtendente.name', label: 'Atendido Por', thStyle: {'width': '8%'}},
        { key: 'status', label: 'Status', thStyle: {'width': '11%'}},
        { key: 'actions', label: '', thStyle: {'width': '8%'}}
      ],
      filtro: {
        idPedidoVindi: null
      }
    };
  }
};
</script>